import React, { useState, useEffect } from 'react';
import PageContainer from '../components/containers/PageContainer';
import { IconButton, TableCell, TableRow, Tooltip, Stack, Button } from '@mui/material';
import api from '../config/axios';
import { toast } from 'react-toastify';
import Field from '../components/ui/Field';
import CustomTable from '../components/ui/CustomTable';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import PriceCheckIcon from '@mui/icons-material/PriceCheck';
import ModalContainer from '../components/containers/ModalContainer';
import { statusMap } from '../utilities/misc';
import StatusComp from '../components/common/StatusComp';

const Invoices = () => {
    const [invoices, setInvoices] = useState([]);
    const [filter, setFilter] = useState('All');
    const [sort, setSort] = useState('des');
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [totalPages, setTotalPages] = useState(0);
    const [total, setTotal] = useState(0);
    const [url, setUrl] = useState('/admin/invoice/read');
    const [showDeleteRequest, setShowDeleteRequest] = useState(false);
    const [search, setSearch] = useState('');
    const [singleRequests, setSingleRequests] = useState({});
    const onCloseDeleteRequestModal = () => {
        setShowDeleteRequest(false);
    };
    const onOpenDeleteRequestModal = () => setShowDeleteRequest(true);
    const [showDeletePending, setShowDeletePending] = useState(false);

    const onCloseDeletePendingModal = () => {
        setShowDeletePending(false);
    };
    const onOpenDeletePendingModal = () => setShowDeletePending(true);
    useEffect(() => {
        getInvoices();
    }, [page, sort, filter, limit, search]);

    const getInvoices = async () => {
        var link = '';

        if (search !== '') {
            link =
                url + '?page=' + page + '&limit=' + limit + '&sort=' + sort + '&status=' + filter + '&search=' + search;
        } else {
            link = url + '?page=' + page + '&limit=' + limit + '&sort=' + sort + '&status=' + filter;
        }

        await api
            .get(link)
            .then((res) => {
                setInvoices(res.data.invoices);
                setTotalPages(res.data.totalPages);
                setTotal(res.data.total);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const markasPaid = async (id) => {
        await api
            .put('/admin/invoice/markaspaid/' + id, {})
            .then((res) => {
                getInvoices();
                toast.success(res.data.message);
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            });
    };

    const markDelete = async (id) => {
        await api
            .delete('/admin//invoice/delete/' + id)
            .then((res) => {
                getInvoices();
                onCloseDeleteRequestModal();
                toast.success(res.data.message);
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            });
    };
    const DeleteAllPending = async (id) => {
        await api
            .put('/admin//invoice/delete')
            .then((res) => {
                getInvoices();
                onCloseDeletePendingModal();
                toast.success(res.data.message);
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            });
    };
    return (
        <PageContainer
            title="View Invoices"
            desc="All your invoices at one place"
            end={
                <Button variant="contained" color="error" onClick={onOpenDeletePendingModal}>
                    Delete All Pending Invoices
                </Button>
            }>
            <Field
                placeholder="Search invoices using transaction ID, username, payment method"
                onChange={(e) => {
                    setSearch(e.target.value);
                }}
            />

            <CustomTable
                sx={{ mt: 2 }}
                fields={[
                    'ID',
                    'USERNAME',
                    'EMAIL',
                    'AMOUNT',
                    'PAYMENT METHOD',
                    'COMMENT',
                    'STATUS',
                    'CREATED AT',
                    'ACTION',
                ]}
                dense={false}
                pagination
                count={totalPages}
                page={page}
                setPage={setPage}>
                {invoices.map((invoice) => (
                    <TableRow key={invoice._id}>
                        <TableCell>{invoice._id}</TableCell>
                        <TableCell
                            sx={{
                                color: 'primary.main',
                            }}>
                            {invoice.user?.username}
                        </TableCell>
                        <TableCell>{invoice.user?.email}</TableCell>
                        <TableCell
                            sx={{
                                color: statusMap[invoice.status].color,
                            }}>
                            {'$' + invoice.amount ? invoice.amount.toFixed(2) : 'N/A'}
                        </TableCell>
                        <TableCell>{invoice.payment_method}</TableCell>
                        <TableCell>{invoice.comment ?? ''}</TableCell>
                        <TableCell>
                            <StatusComp status={invoice.status} />
                        </TableCell>
                        <TableCell>{new Date(invoice.createdAt).toLocaleString()}</TableCell>
                        <TableCell>
                            <Stack direction="row">
                                <a href={invoice.hosted_url}>
                                    <IconButton>
                                        <VisibilityOutlinedIcon fontSize="small" />
                                    </IconButton>
                                </a>

                                {invoice.status !== 'paid' && (
                                    <Tooltip title="Mark as paid">
                                        <IconButton
                                            onClick={() => {
                                                markasPaid(invoice._id);
                                            }}>
                                            <PriceCheckIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                )}
                                {invoice.status !== 'paid' && (
                                    <IconButton
                                        onClick={() => {
                                            setSingleRequests(invoice);
                                            onOpenDeleteRequestModal();
                                        }}>
                                        <DeleteOutlineOutlinedIcon fontSize="small" />
                                    </IconButton>
                                )}
                            </Stack>
                        </TableCell>
                    </TableRow>
                ))}
            </CustomTable>
            <ModalContainer
                open={showDeleteRequest}
                onClose={onCloseDeleteRequestModal}
                title="Delete Invoice"
                hideActions>
                Are you sure you want to Delete this transaction??
                <div>
                    <Button
                        variant="contained"
                        color="error"
                        className="float-end"
                        onClick={() => markDelete(singleRequests?._id)}>
                        Delete
                    </Button>
                    <Button onClick={() => onCloseDeleteRequestModal()} className="float-end">
                        Close
                    </Button>
                </div>
            </ModalContainer>
            <ModalContainer
                open={showDeletePending}
                onClose={onCloseDeletePendingModal}
                title="Delete All Pending Invoice"
                hideActions>
                Are you sure you want to Delete All this PENDING transaction??
                <div>
                    <Button variant="contained" color="error" className="float-end" onClick={() => DeleteAllPending()}>
                        Delete
                    </Button>
                    <Button onClick={() => onCloseDeletePendingModal()} className="float-end">
                        Close
                    </Button>
                </div>
            </ModalContainer>
        </PageContainer>
    );
};

export default Invoices;
